import type { ProfileResponse } from "api/auth";
import { useCallback, useMemo } from "react";
import {
  //type Profile,
  setIsAuth as setIsAuthAction,
  setProfile as setProfileAction,
  logout as logoutAtion
} from "store/authSlice";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { getDomain, globalLogout } from "utils/helpers";
import {
  removeLocalStorageAccessToken,
  removeLocalStorageItem,
} from "utils/helpers/localStorage";

export const useAuth = () => {
  // const dispatch = useAppDispatch();
  const authState = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();

  
  const setIsAuth = useCallback(
    (isAuth: boolean) => {
      dispatch(setIsAuthAction(isAuth));
    },
    [dispatch]
  );

  const setProfile = useCallback(
    (profile: ProfileResponse) => {
      dispatch(setProfileAction(profile));

      const value = btoa(JSON.stringify({
        username: profile.username
      }))

      const domainName = getDomain();
      document.cookie = "atlantic_sso_user="+value+"; expires=Session; path=/; secure; SameSite=Lax; domain=." + domainName;
    },
    [dispatch]
  );

  const logout = useCallback((deleteCookie: boolean = true) => {
    dispatch(logoutAtion())
    globalLogout(deleteCookie);
  }, [dispatch]);

  // const getProfile = useCallback(() => {
  //   return dispatch(getProfileAction());
  // }, [dispatch]);

  // const logout = useCallback(() => {
  //   removeAuthTokens();
  //   return dispatch(logoutAction());
  // }, [dispatch]);

  return useMemo(
    () => ({
      isAuth: authState.isAuth,
      setIsAuth,
      setProfile,
      logout,
      ...authState.profile,
    }),
    [authState.isAuth, authState.profile, logout, setIsAuth, setProfile]
  );
};
